const store = new Map();
export const userStaleDataStore = {
    set(cb, conn) {
        const existingKey = store.get(cb);
        if (existingKey) {
            existingKey.add(conn);
        }
        else {
            store.set(cb, new Set([conn]));
        }
    },
    get(cb) {
        const existingKey = store.get(cb);
        return existingKey ? [...existingKey] : [];
    },
    getKeys() {
        return [...store.keys()];
    },
    has(cb) {
        return store.has(cb);
    },
    delete(cb, conn) {
        const existingKey = store.get(cb);
        if (existingKey) {
            existingKey.delete(conn);
            if (existingKey.size === 0) {
                return store.delete(cb);
            }
        }
        return false;
    },
    deleteConnection(conn) {
        return userStaleDataStore.getKeys().forEach(cb => {
            userStaleDataStore.delete(cb, conn);
        });
    },
    clear() {
        store.clear();
    }
};
// exposing a prop on window for easier debugging in development builds
// no need to test it...
/* istanbul ignore next */
if (process.env.NODE_ENV === "development") {
    window["__SBDATALAYER__USER_STALE_DATA_STORE"] = userStaleDataStore;
}
//# sourceMappingURL=UserStaleDataStore.js.map